import baseMixin from './baseMixin'
import {
    styler,
    keyframes,
    easing,
    chain,
    delay,
    spring,
    composite,
    tween,
    action
} from 'popmotion'
import { shuffle } from 'lodash'

export default {
    mixins: [baseMixin],

    beforeCreate() {
        this.baseElementQueryString = 'perpetuating-innovation-graphic'
    },

    methods: {
        setStyler() {
            const NUM_FRAMES = 5

            // For each frame get an array of elements
            const frames = Array.from(Array(NUM_FRAMES).keys()).map(i =>
                shuffle(
                    Array.from(
                        this.baseElement.querySelectorAll(`#pi-frame-${i} path`)
                    )
                )
            )

            // For each frame get the XY positions of each element && flatten so we
            // can use in keyframes
            // const positions = frames.map(frame => frame.map(this.getXY).flat())
            const positions = frames.map(frame =>
                frame.map(this.getXY).reduce((acc, val) => acc.concat(val), [])
            )

            // Get the delta values of each frame
            const deltas = positions.map(to => {
                const from = positions[positions.length - 1]
                return to.map((p, i) => p - from[i])
            })

            // init
            let stylers

            frames.forEach((frame, i) => {
                if (i === frames.length - 1) {
                    // if its the final frame create stylers

                    stylers = frame.map(element => styler(element))
                } else {
                    // otherwise hide the elements
                    frame.forEach(element => (element.style.opacity = 0))
                }
            })

            const groupStyler = styler(
                this.baseElement.querySelector(`#pi-frame-${NUM_FRAMES - 1}`)
            )

            this.deltas = deltas
            this.stylers = stylers
            this.groupStyler = groupStyler
        },

        animationAction() {
            let final = this.deltas[this.deltas.length - 1]
            return composite({
                movement: chain(
                    keyframes({
                        values: this.deltas.slice(0, -1),
                        duration: 600,
                        ease: easing.linear
                    }),
                    spring({
                        from: this.deltas[this.deltas.length - 2],
                        to: this.deltas[this.deltas.length - 1],
                        damping: 9
                    })
                ),
                rotation: chain(
                    delay(700),
                    tween({
                        from: { rotate: 0 },
                        to: { rotate: 720 },
                        duration: 2000,
                        ease: easing.linear
                    })
                ),
                colour: chain(
                    delay(1000),
                    tween({
                        from: { fill: '#ffffff' },
                        to: { fill: '#F14F1D' },
                        ease: easing.linear
                    })
                )
            })
        },

        skipToStart() {
            return action(({ update, complete }) => {
                update(true)
                complete()
            })
        },

        initAction() {
            return composite({
                opacity: chain(
                    tween({ from: 1, to: 0, duration: 200 }),
                    delay(200),
                    tween({ from: 0, to: 1, duration: 200 })
                ),
                reset: chain(delay(300), this.skipToStart())
            })
        },

        initReaction(values) {
            if (!values) return

            const { opacity, reset } = values

            opacity && this.groupStyler.set({ opacity })

            if (reset) {
                const positions = this.deltas[0]
                this.stylers.forEach((styler, i) =>
                    styler.set({
                        x: positions[i * 2],
                        y: positions[i * 2 + 1]
                    })
                )
                this.groupStyler.set({ rotate: 0, fill: '#ffffff' })
            }
        },

        animationReaction(values) {
            const { movement, rotation, colour } = values

            if (movement) {
                this.stylers.forEach((styler, i) =>
                    styler.set({
                        x: movement[i * 2],
                        y: movement[i * 2 + 1]
                    })
                )
            }

            rotation && this.groupStyler.set(rotation)

            colour && this.groupStyler.set(colour)
        },

        getXY(el) {
            const { x, y } = el.getBBox()
            return [x, y]
        },

        deltaXY(to, from) {
            let returnObject = {}
            for (const v in to) {
                returnObject[v] = to[v] - from[v]
            }
            return returnObject
        }
    }
}
